import { e as error } from "../../../../../chunks/index2.js";
import { U as UserCollection } from "../../../../../chunks/firebase.js";
const POST = async ({ request, locals }) => {
  const body = await request.json();
  const id = body.id;
  if (!id || id?.length !== 64) {
    return error(400, { message: "Device ID is required" });
  }
  await UserCollection().doc(id).set({
    ...locals.user,
    id
  });
  return new Response(null, { status: 200 });
};
export {
  POST
};
